import React, { useEffect, useState } from "react"

const ERROR = `OneTrust was not loaded correctly.`

const handleCsp = (e) => {
  e?.preventDefault()

  if (
    window.OneTrust &&
    typeof window.OneTrust.ToggleInfoDisplay === "function"
  ) {
    try {
      window.OneTrust.ToggleInfoDisplay()
    } catch (error) {
      console.error("OneTrust error.", error)
    }
  } else {
    console.warn(ERROR)
  }
}

const AdChoicesLink = () => {
  const [apiLoaded, setApiLoaded] = useState(true)

  useEffect(() => {
    let cspInterval,
      cnt = 0
    if (process.env.GATSBY_CSP_ID) {
      cspInterval = setInterval(() => {
        if (cnt === 20) {
          clearInterval(cspInterval)
          console.error(ERROR)
        }
        if (window.OneTrust) {
          setApiLoaded(true)
          // eslint-disable-next-line no-console
          console.log("OneTrust loaded.")
          clearInterval(cspInterval)
        } else {
          cnt++
        }
      }, 500)
    }

    return () => {
      return cspInterval && clearInterval(cspInterval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return apiLoaded ? (
    <button
      className={`text-left md:pr-[24px] ${
        process.env.GATSBY_RENDER_CSP === "1" ? "block" : "hidden"
      }`}
      onClick={(e) => {
        handleCsp(e)
      }}
    >
      <span className="">AdChoices - Do Not Sell Or Share</span>
    </button>
  ) : null
}

export default AdChoicesLink
